import { useState } from "react";
import { usePwa } from "@client/pwa";

/**
 * Coordinator seam between C5 (usePwa) and C1 (shell): the install banner (F-703) and the update toast (F-701).
 * Applying an update reloads the page; the cart draft is persisted (F-409), so a tap here never loses a sale.
 */
export function PwaBanners() {
  const pwa = usePwa();
  const [showSteps, setShowSteps] = useState(false);
  const copy = pwa.installCopy;
  const showInstall = !pwa.isStandalone && copy !== null && pwa.installDismissals < 3;

  return (
    <>
      {pwa.updateReady ? (
        <div className="wc-banner wc-banner--info" role="status">
          <span>A new version of WebCashier is ready.</span>
          <div className="wc-banner__actions">
            <button type="button" className="wc-banner__btn" onClick={() => void pwa.applyUpdate()}>
              Update now
            </button>
          </div>
        </div>
      ) : null}
      {showInstall ? (
        <div className="wc-banner wc-banner--warn" role="region" aria-label="Install WebCashier">
          <strong>{copy.title}</strong>
          <p className="wc-banner__body">{copy.body}</p>
          {showSteps ? (
            <ol className="wc-banner__steps">
              {copy.steps.map((s) => (
                <li key={s}>{s}</li>
              ))}
            </ol>
          ) : null}
          <div className="wc-banner__actions">
            <button
              type="button"
              className="wc-banner__btn"
              onClick={() => {
                if (pwa.canInstall) void pwa.promptInstall();
                else setShowSteps((v) => !v);
              }}
            >
              {copy.cta}
            </button>
            <button type="button" className="wc-banner__btn wc-banner__btn--quiet" onClick={() => pwa.dismissInstall()}>
              {copy.dismiss}
            </button>
          </div>
        </div>
      ) : null}
      {pwa.persisted === false && pwa.isStandalone ? (
        <p className="wc-banner wc-banner--warn" role="status">
          This device has not granted durable storage yet. Export a backup from Setup → Data after each market day.
        </p>
      ) : null}
    </>
  );
}
